module.exports = __webpack_public_path__ + "media/images/home/card_teaching_resources-e9a6aa442c9c22021981e66768caeeea.jpg";